import React, { useEffect, useRef, useState } from "react";
import { ChevronDown } from "react-feather";
import * as FeatherIcon from "react-feather";

import "./index.scss";

export function Accordion({
  title,
  icon,
  wide = false,
  align = "left",
  open = false,
  children,
}) {
  const [isOpen, setIsOpen] = useState(open ? open : false);
  const [heightContent, setHeightContent] = useState("");
  const refContent = useRef();

  useEffect(() => {
    function defineHeightContent() {
      /* Why +8? Margin-top of content*/
      if (refContent.current.scrollHeight > 0) {
        setHeightContent(`${refContent.current.scrollHeight + 8}px`);
      }
    }

    window.addEventListener("resize", defineHeightContent);

    return () => {
      window.removeEventListener("resize", defineHeightContent);
    };
  }, []);

  function handleToggle() {
    setIsOpen((prevState) => !prevState);
  }

  function returnClassName() {
    let className = "accordion__toggle";

    if (wide) className += " accordion__toggle--wide";
    if (align === "left") className += " accordion__toggle--left";
    if (align === "right") className += " accordion__toggle--right";

    return className;
  }

  const CustomIcon = ({ sizeIcon }) => {
    const Icon = FeatherIcon[icon];
    return <Icon size={sizeIcon} />;
  };

  return (
    <div className="accordion">
      <button className={returnClassName()} onClick={handleToggle}>
        <span>
          {icon && <CustomIcon sizeIcon={20} />}
          {title}
        </span>
        <ChevronDown
          className={`accordion__chrevron ${
            isOpen ? "accordion__chrevron--expanded" : ""
          }`}
          size={20}
        />
      </button>

      <div
        ref={refContent}
        className={`accordion__content ${
          isOpen ? "accordion__content--expanded" : ""
        }`}
        // style={{
        //   height: isOpen ? heightContent : "0px",
        // }}
      >
        {children}
      </div>
    </div>
  );
}
